module.exports = __webpack_public_path__ + "filegrid.png?d60a2ce7a48f1e6043f9bca4980db983";